export default "__VITE_ASSET__Dic10iPs__ 600w";